import { MatchKeysAndValues } from "../../../@components/interfaces.js";
import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class UsersTemp {
	async loginwithBirthday(cred: { dpi: string; birthday?: number }) {
		let response = await xhttp<{ token: string; data: PGSchema.users }>(`/users_temp/auth/birthday`, "POST", cred);
		return response;
	}

	async register(user: PGSchema.users) {
		let response = await xhttp<{ token: string; data: PGSchema.users }>(`/users_temp/register`, "POST", { user: user });
		return response;
	}

	async getInfo() {
		let response = await xget<{ user: PGSchema.users }>(`/users_temp/me`);
		return response;
	}

	async editInfo(info: MatchKeysAndValues<PGSchema.users>) {
		let response = await xhttp<PGSchema.users>(`/users_temp/me`, "PATCH", info);
		return response;
	}

	resetPasswd(dpi: string) {
		return xhttp<{ ok: boolean }>(`/users_temp/resetpasswd`, "PUT", { uid: `-tmp-${dpi}` });
	}
}
